
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZList',
  props: {
    title: {
      type: String
    }
  }
})
